<template>
  <!-- 兑换优惠券 （待）-->
  <div class="exchange flex-between fs2">
    <div class="input-wrap"><input type="text" v-model="couponNum" @change="change" placeholder="输入优惠码"></div>
    <div class="exchange-btn flex-center" @click="toExchange">兑换</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      couponNum: '',
    }
  },
  methods: {
    toExchange() {
      if (this.couponNum) {
        // receiveCoupon(this.couponNum).then(res => {
        //   this.$toast('成功领取');
        //   this.$emit('success');
        // })
      }
    },
    change(e) {
      console.log(111, e.target.value)
      console.log(222, this.couponNum)
    },
  }
}
</script>

<style lang="less">
.exchange {
  padding: .1rem;
  background: #fff;
}
.exchange .input-wrap {
    -webkit-box-flex: 1;
        -ms-flex: 1;
            flex: 1;
    padding: 0 .1rem;
}
.exchange .input-wrap input {
      width: 100%;
      color: #666;
      border: 0;
}
.exchange .exchange-btn {
    width: .75rem;
    height: .3rem;
    background: #56D176;
    border: 0.01rem solid #34c059;
    color: #fff;
    border-radius: .05rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CouponExchange.vue